import { coalesceLocaleField } from '../helpers/coalesceLocaleField'
import { groq } from 'next-sanity'
import { LocaleId } from '@portfolio/configs'
import { createMediaProjection } from '../projections/createMediaProjection'
import { createEditorialRichTextProjection } from '../projections/createEditorialRichTextProjection'
import { createBaseImageProjection } from '../projections/createBaseImageProjection'

export const createSectionAwardArticlesProjection = (localeId: LocaleId) => {
  const MEDIA_PROJECTION = createMediaProjection(localeId)
  const EDITORIAL_RICH_TEXT_PROJECTION =
    createEditorialRichTextProjection(localeId)

  return groq`{
        _key,
        _type,
        ${coalesceLocaleField('title', localeId)},
        spacing,
        topBorder,
        articles[] {
          _key,
          articleRef->{
          _key,
            thumbnail${MEDIA_PROJECTION},
            ${coalesceLocaleField('title', localeId)},
            "path":path.current,
            ${coalesceLocaleField(
              'introduction',
              localeId,
            )}[]${EDITORIAL_RICH_TEXT_PROJECTION},
          },
          ${coalesceLocaleField('shortDescription', localeId)},
          ${coalesceLocaleField('linkLabel', localeId)},
          media${MEDIA_PROJECTION},
          logo${createBaseImageProjection(localeId)},
        },
      }
  `
}
